// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__rhowG","col":"styles_col__1igE3","fulfillmentStatus":"styles_fulfillmentStatus__313lB","emailCol":"styles_emailCol__mHI7D"};